import React from 'react';

import { ModalProps } from '../../../../components/Modal';
import { DoctorScheduling } from '../../../../components/Icons/DoctorScheduling';

import { SimpleModal } from '../../../../components/SimpleModal';

export type SystemUnavailableProps = Pick<ModalProps, 'visible' | 'onClose'>;

export const FirstAppointmentUnderTimeLimitModal: React.FC<SystemUnavailableProps> = ({ visible, onClose }) => {
  return (
    <SimpleModal
      visible={visible}
      onClose={onClose}
      title="Retornos indisponíveis para agendamento"
      subtitle="O agendamento das consultas de retorno com o clínico geral e a equipe multidisciplinar estarão disponíveis após 10 dias da realização do seu Check-up."
      mainIcon={<DoctorScheduling />}
    />
  );
};
